import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from 'firebase/auth';

const firebaseConfig =  {
  apiKey:`${process.env.REACT_APP_API_KEY}`,
  authDomain:`${process.env.REACT_APP_AUTH_DOMAIN}`,
  projectId:`${process.env.REACT_APP_PROJECT_ID}`,
  storageBucket:`${process.env.REACT_APP_STORAGE_BUCKET}`,
  messagingSenderId:`${process.env.REACT_APP_MESSAGING_SENDER_ID}`,
  appId:`${process.env.REACT_APP_APP_ID}`,
  ...(process.env.REACT_APP_MEASUREMEN_ID && {measurementId: `${process.env.REACT_APP_MEASUREMEN_ID}`}) 
}
// Initialize Firebase and Firestore
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const firestore = getFirestore(app);
export { db,auth,firestore};
